import { render, staticRenderFns } from "./TarjetaAudio.vue?vue&type=template&id=8d9b92b6&lang=pug&"
import script from "./TarjetaAudio.vue?vue&type=script&lang=js&"
export * from "./TarjetaAudio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports